import React from "react";
import { Redirect, Route } from "react-router-dom";
import { CONSTANTES } from "../../utils/Constantes";
import { getLocalStorage } from "../../utils/LocalStorage";

const PrivateRoute = ({ component: Component, ...rest }) => {
  let isUserLoggedIn = getLocalStorage("user") || null;

  return (
    <Route
      {...rest}
      render={(props) =>
        isUserLoggedIn ? (
          <Component {...props} />
        ) : (
          <Redirect to={CONSTANTES.RUTA.login} />
        )
      }
    />
  );
};

export default PrivateRoute;
